<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1" title-tag="h5">
            Warehouse Items that Expire Soon
          </b-card-title>
        </div>

        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >in the next 2 months, or already did
        </span>
        <!-- datepicker -->
      </b-card-header>

      <b-card-body class="p-0">
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <TableListing
          v-if="items"
            class="mt-0"
            moreCustom5Class="nopadinr"
            sticky-header
            :responsive="true"
            :fixed="false"
            head-variant="light"
            :hide-pagination-top-fields="true"
            :loading-page="isLoadingChartData"
            :items.sync="items"
            :showPaginationRow="false"
            :fields.sync="tableColumns"
            :bordered="false"
          >
            <template v-slot:cell(createDateTimeUtc)="data">
              <span
                v-if="
                  data.item.createDateTimeUtc &&
                    !data.item.createDateTimeUtc.endsWith('Z')
                "
                >{{
                  (data.item.createDateTimeUtc + 'Z') | moment('MMM Do YY, h:mm a')
                }}</span
              >
              <span v-else-if="data.item.createDateTimeUtc">{{
                data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
              }}</span>
            </template>
            <template v-slot:cell(expirationDate)="data">
              <span
                v-if="
                  data.item.expirationDate &&
                    !data.item.expirationDate.endsWith('Z')
                "
                >{{
                  (data.item.expirationDate + 'Z') | moment('MMMM Do YYYY')
                }}</span
              >
              <span v-else-if="data.item.expirationDate">{{
                data.item.expirationDate | moment('MMMM Do YYYY')
              }}</span>
            </template>
            <template v-slot:cell(status)="data">
              <span v-if="data.item.isQuarantined" class="badge badge-danger">Quarantined</span>
              <span v-else-if="data.item.isOnHold" class="badge badge-info">On Hold</span>
              <span v-else class="badge badge-success">Available</span>
            </template>

            <template v-slot:cell(warehouseProduct.brandId)="data">
              <span
                v-if="myBrands && myBrands.find(a => a.id == data.item.warehouseProduct.brandId)"
                >{{ myBrands.find(a => a.id == data.item.warehouseProduct.brandId).name }}</span
              >
              <span v-else>-</span>
            </template>
            <template v-slot:cell(warehouseProduct.warehouseId)="data">
              <span
                v-if="myWarehouses && myWarehouses.find(a => a.id == data.item.warehouseProduct.warehouseId)"
                >{{ myWarehouses.find(a => a.id == data.item.warehouseProduct.warehouseId).name }}</span
              >
              <span v-else>-</span>
            </template>
          </TableListing>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import { TableListing, LoadOnVisible } from '@/views/components/custom';

export default {
  mixins: [myCommonDataMixin],
  components: {
    TableListing: TableListing,
    LoadOnVisible
  },
  data() {
    return {
      tableOpts: {
        totalRows: 0,
        loadedAll: true
      },
      items: [],
      tableColumns: [
      { key: 'warehouseProduct.brandId', label: 'Client', sortable: true },
      { key: 'warehouseProduct.warehouseId', label: 'Warehouse', sortable: true },
      { key: 'warehouseProduct.item', label: 'Item', sortable: true },
      //{ key: 'warehouseProduct.description', label: 'Description', sortable: true },
      //{ key: 'lotNumber', label: 'Lot Number', sortable: true },
      { key: 'warehouseLocation.code', label: 'Pallet #', sortable: true },
      { key: 'warehouseLocation.parentLocation.code', label: 'Location', sortable: true },
      { key: 'quantityAvailable', label: 'Avail.', sortable: true },
      //{ key: 'quantityAvailable', label: 'Available', sortable: true },
      //{ key: 'quantityOnHold', label: 'On Hold', sortable: true },
      //{ key: 'quantityUnavailable', label: 'Unavailable', sortable: true },
      { key: 'status', label: 'Status', sortable: false },
      { key: 'expirationDate', label: 'Expires At', sortable: true },
      ],
      isLoadingChartData: true
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  methods: {
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/warehouseProductLocations/listItems', {
          sortBy: 'expirationDate',
          sortDesc: false,
          perPage: 100,
          status: 'Available',
          expirationDateEnd: (new Date(new Date().setDate(new Date().getDate() + 60)).toISOString().split('T')[0])
        })
        .then(resp => {
          this.isLoadingChartData = false;
          this.items = resp.data.items;
          this.tableOpts.totalRows = this.items.length;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.items = [];
        });
    }
  },
  mounted() {
  }
};
</script>
